module.exports = __webpack_public_path__ + "img/list-app.238d03b4.svg";